export function isEmailValid(email) {
  const emailDomain = email.split("@")[1];
  const validEmailDomains = [
    "go-jek.com",
    "gojek.com",
    "go-pay.co.id",
    "gopay.co.id",
    "getthailand.com",
    "go-viet.vn",
    "goviet.vn",
    "aux.go-jek.com",
    "aux.gojek.com",
    "tokopedia.com",
    "gotocompany.com",
    "findaya.co.id",
  ];

  return validEmailDomains.some(
    (validEmailDomain) => emailDomain === validEmailDomain
  );
}
